import { Col, Container, Row } from 'react-bootstrap';
import { motion } from 'motion/react';
import CountUp from 'react-countup';
import digitalData from '../../data/digitalData.json';

const Outcomes = () => {
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: { staggerChildren: 0.2 }
    }
  }

  const cardVariants = {
    hidden: { opacity: 0, scale: 0.8 },
    visible: {
      opacity: 1,
      scale: 1,
      transition: { duration: 0.5, ease: "easeOut" }
    }
  }

  return (
    <section className='section-lg bg-light'>
      <Container>
        <Row className="text-center mb-5">
          <Col lg={8} className="mx-auto text-center">
            <div className="service-heading mb-3">
              <motion.h6 className="underline-after text-center position-relative z-0"
                initial={{ opacity: 0, y: -20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
              >
                <span className="position-relative z-1 bg-white text-primary px-3">Our Impact</span>
              </motion.h6>
              <motion.h2 className="d-block text-gradiant text-center fw-semibold display-5"
                initial={{ opacity: 0, scale: 0.9 }}
                whileInView={{ opacity: 1, scale: 1 }}
                viewport={{ once: true }}
                transition={{ delay: 0.1 }}
              >
                Driving Real Results
              </motion.h2>
            </div>
            <motion.p className="lead text-secondary"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: 0.2 }}
            >
              We've helped businesses of all sizes achieve measurable growth through our digital marketing strategies.
            </motion.p>
          </Col>
        </Row>
        <motion.div
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.2 }}
        >
          <Row className="g-4 text-center">
            {digitalData.outcomes.map((outcome) => (
              <Col lg={3} md={6} key={outcome.id}>
                <motion.div variants={cardVariants}
                  whileHover={{ y: -10, scale: 1.05, transition: { duration: 0.3 } }}
                >
                  <div className="card h-100 border-0 shadow-sm rounded-4 hover-shadow transition-all">
                    <div className="card-body p-4">
                      <div className="display-4 fw-bold text-success mb-2">
                        {outcome.hasCountUp ? (
                          <>
                            <CountUp end={outcome.value} duration={2.5} enableScrollSpy scrollSpyOnce />
                            {outcome.suffix}
                          </>
                        ) : (
                          outcome.value
                        )}
                      </div>
                      <h5 className="fw-semibold mb-2 text-dark">{outcome.title}</h5>
                      <p className="text-secondary small mb-0">{outcome.description}</p>
                    </div>
                  </div>
                </motion.div>
              </Col>
            ))}
          </Row>
        </motion.div>
      </Container>
    </section>
  )
}

export default Outcomes;
